import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["colspan"]
const _hoisted_2 = { class: "flex items-center justify-center gap-1.5" }


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseTableLoader',
  props: {
    colspan: { default: 5 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", {
      colspan: _ctx.colspan,
      class: "py-16"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
          return _createElementVNode("span", {
            key: i,
            class: "h-2.5 w-2.5 rounded-full bg-primary dark:bg-primary-dark",
            style: _normalizeStyle({ animationDelay: `${(i - 1) * 0.15}s` })
          }, null, 4)
        }), 64))
      ])
    ], 8, _hoisted_1)
  ]))
}
}

})